import React from 'react';
import { BasketTableContext } from '../contexts/table';
import { useBasketsTable } from '../hooks/use-table';
import { NextTable } from '@shared/modules/next-table/containers';

export const BasketTable = () => {
  const { columns, getRowProps } = useBasketsTable();

  return <NextTable context={BasketTableContext} columns={columns} getRowProps={getRowProps} />;
};
